export const getReactRouterBasename = () => {
  const reactRouterBasename = 'REACT_ROUTER_BASE_NAME_PLACEHOLDER';
  const useBaseNamePlaceholder = 'REACT_ROUTER_BASE'.concat('_NAME_PLACEHOLDER');

  return reactRouterBasename === useBaseNamePlaceholder ? '' : reactRouterBasename;
};
